import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { BankAccount, BankAccountsService } from 'src/app/shared/services/bank-accounts.service';
import { FabButton } from 'src/app/nav/fab-menu/fab-menu.component';

@Component({
  selector: 'app-bank-accounts-list',
  templateUrl: './bank-accounts-list.component.html',
  styleUrls: ['./bank-accounts-list.component.scss']
})
export class BankAccountsListComponent implements OnInit {
  loading: boolean = true;
  noBankAccountsFound: boolean = false;
  bankAccounts: BankAccount[] = new Array<BankAccount>();

  fabButtons: FabButton[] = [
    {
      icon: 'key',
      label: 'Credentials',
      route: '/bank/accounts/providers/credentials'
    }
  ];

  constructor(private bankAccSvc: BankAccountsService) {

  }
  ngOnInit(): void {
    this.loading = true;
    this.bankAccSvc.getBankAccounts()
      .subscribe({
        next: (data: BankAccount[]) => {
          this.bankAccounts = data;
          this.noBankAccountsFound = false;
          this.loading = false;
        },
        error: (err: HttpErrorResponse) => {
          if (err.status == 404 && err.error === "No bank accounts found.") {
            this.noBankAccountsFound = true;
            this.loading = false;
          } else {
            throw err;
          }
        }
      });
  }
}
